module.exports = __webpack_public_path__ + "img/home-world-best-banner-01-on.9fedbb09.jpg";